import React, { useState } from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { globalDB } from "../../store/globalStore";
import { useLiveQuery } from "dexie-react-hooks";
import axios from "axios";

export default function LanguageSelect() {
  const [lang, setLang] = useState("en");
  const selectedLanguage = useLiveQuery(() => globalDB.language.toArray());

  const handleChange = (event) => {
    setLang(event.target.value);
    axios
      .get(
        `https://dme-staging-1f15eaad7fd6.herokuapp.com/api/page_text/${event.target.value}`,
      )
      .then((res) => {
        // update global store language to match selected language
        globalDB.language.put({ iso_code: event.target.value, id: 1 });
        //change other pagecontent objects to inactive
        globalDB.pageContent.where("active").equals(1).modify({ active: 0 });

        globalDB.pageContent.put({
          lang: event.target.value,
          page_content: res.data,
          active: 1,
        });
      });
  };

  return (
    <Box
      sx={{ padding: 0 }}
      anchororigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      keepmounted="true"
      transformorigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
    >
      <FormControl fullWidth size="small">
        <Select
          value={
            selectedLanguage && selectedLanguage[0]
              ? selectedLanguage[0].iso_code
              : lang
          }
          label="Language..."
          onChange={handleChange}
        >
          <MenuItem value={"en"}>English</MenuItem>
          <MenuItem value={"es"}>Español</MenuItem>
          <MenuItem value={"am"}>አማርኛ</MenuItem>
          <MenuItem value={"fr"}>Français</MenuItem>
          <MenuItem value={"vi"}>Tiếng Việt</MenuItem>
          <MenuItem value={"zh-CN"}>中文</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
